/** Weekday codes derived from nanny schedule `hours` strings (matches JobDetails / job search). */
export function deriveNannyDaysFromHours(hours: unknown[] | undefined | null): string[] {
  let returnArr: string[] = [];
  const list = Array.isArray(hours) ? hours : [];
  if (list.some((str) => typeof str === 'string' && str.includes('WEEKDAY'))) {
    returnArr = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
  }
  if (list.some((str) => typeof str === 'string' && str.includes('WEEKENDS'))) {
    returnArr = [...returnArr, 'SATURDAY', 'SUNDAY'];
  }
  return returnArr;
}

export function isNannyCareType(careType: string | undefined | null): boolean {
  return typeof careType === 'string' && careType.toUpperCase() === 'NANNY';
}

export interface JobScheduleDisplayInput {
  careType?: string | null;
  scheduleType?: string | null;
  schedule?: Record<string, unknown> | null;
}

/** Minimal slice passed as `JobSchedule`’s `job` prop—always set `isActive` (`false` greys the schedule UI). */
export type JobScheduleJobProp = JobScheduleDisplayInput & {
  isActive: boolean;
};

/** Shapes `schedule` + `scheduleType` for JobSchedule (nanny: merge `hours` → `days`). */
export function buildSchedulePayloadForJobSchedule({ careType, scheduleType, schedule }: JobScheduleDisplayInput): {
  scheduleType: string;
  schedule: Record<string, unknown>;
} {
  const st = scheduleType ?? '';
  const sch = schedule && typeof schedule === 'object' ? { ...schedule } : {};

  if (isNannyCareType(careType)) {
    const hours = sch.hours as unknown[] | undefined;
    return {
      scheduleType: st,
      schedule: { ...sch, days: deriveNannyDaysFromHours(hours) },
    };
  }

  return { scheduleType: st, schedule: sch };
}
